import { runGame } from './pokerTrigger'
import { isOpenedGame, moveGameScene } from '../config'

/**
 * PC 클라 웹뷰 : 아이템함 | 선물함 이동, 게임홈에서는 그냥 게임 실행
 * @param {'MyBagItem' | 'MyBagGift'} sceneName
 */
export function runGameOrGoScene(sceneName = 'MyBagItem') {
  if (isOpenedGame) {
    window.location.href = moveGameScene(sceneName)
  } else {
    runGame()
  }
}
